import React, { Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router';
import { LogoLoading } from "../../components/Loading";

// Only import the dataset builder for researchers
const DatasetBuilder = React.lazy(() => import('../../pages/Admin/DatasetBuilder'));

function ResearcherRoutes() {
  return (
    <Suspense fallback={<LogoLoading />}>
      <Routes>
        <Route path="/" element={<DatasetBuilder />} />
        <Route path="/dataset-builder" element={<DatasetBuilder />} />
        {/* Catch-all route to prevent them from going anywhere else */}
        <Route path='*' element={<Navigate to="/" />} />
      </Routes>
    </Suspense>
  )
}

export default ResearcherRoutes;
